import { useEffect, useRef } from 'react';
import useGetPlayerEl from 'chameleon/packages/blue-book-player/hooks/useGetPlayerEl';
import { getItemByRef } from 'chameleon/packages/blue-book-player/utils';
import { getAnchorElements } from 'chameleon/packages/blue-book-player/InnerContainer/utils';

const useProcessAnchors = (playerState, learnosityApp) => {
  const playerEl = useGetPlayerEl();
  const loadedQuestions = useRef({});

  useEffect(() => {
    const onItemLoad = () => {
      const { features, reference } = learnosityApp.getCurrentItem();
      if (loadedQuestions.current[reference]) {
        return;
      }
      if ((features?.length ?? 0) > 0) {
        loadedQuestions.current[reference] = true;
        const questionElement = getItemByRef(playerEl, reference);
        getAnchorElements(questionElement)?.forEach((anchorEl) => {
          if (!anchorEl) {
            return;
          }

          const href = anchorEl?.getAttribute('href');
          anchorEl.setAttribute('href', `${href}-${reference}`);
          if (href.startsWith('#')) {
            const anchoredTextEl = questionElement?.querySelector(href);
            anchoredTextEl?.classList?.add('anchor-has-leader');
            anchoredTextEl?.setAttribute(
              'id',
              `${href.replace('#', '')}-${reference}`,
            );
          }
        });
      }
    };
    learnosityApp?.on('item:load', onItemLoad);

    return () => {
      learnosityApp?.off('item:load', onItemLoad);
    };
  }, [playerState?.isTestReady, playerEl, loadedQuestions.current]);

  return null;
};

export default useProcessAnchors;
